import React, { useState } from "react";
import CustomCsPcInput from "../../components/dms_common/CustomCsPcInput";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Checkbox from "@mui/material/Checkbox";
import { DeliveryInvoiceBatchDetails } from "../../types/types";
import { getUomLabel } from "../../components/dms_common/DmsUtils";


const PrimaryReturnSelect = ({
  label,
  isSelected,
  onSelect,
}: {
  label: string;
  isSelected: boolean;
  onSelect: () => void;
}) => {

  return (
    <div
      style={{
        width: "min-content",
        whiteSpace: "nowrap",
        cursor: "pointer",
        backgroundColor: isSelected ? "#227C9D" : "transparent",
        borderRadius: "20px",
        display: "flex", alignItems: "center"
      }}
      onClick={onSelect}
    >
      <span style={{fontSize: "12px", gap: "6px", color: `${isSelected ? "white" : "#7C7C7C"}`, padding: "6px 10px" }}>
        <span style={{fontWeight: isSelected ? 500 : 400}}> {label}{" "}</span>
    </span>
      
    </div>
  );
};

export default PrimaryReturnSelect;